"use strict";
exports.__esModule = true;
var SettingsResponse;
(function (SettingsResponse) {
    var Settings = (function () {
        function Settings() {
        }
        return Settings;
    }());
    SettingsResponse.Settings = Settings;
})(SettingsResponse || (SettingsResponse = {}));
exports.SettingsResponse = SettingsResponse;



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/settings.js
// module id = ../model/dist/models/settings.js
// module chunks = main